"use client";

import { KeyedMutator } from "swr";

import { PermissionActions, PermissionsRecord } from "@/backend/domains/permission";

import { useServerAction } from "@/hooks/useServerAction";
import { createAdvancedStore } from "@/stores/createAdvancedStore";
import { clientApi } from "@/actions";
import { PermissionErrorAction } from "@/errors/permission.errors";

//

type PermissionsStore = {
  permissions: PermissionsRecord;
  mutate: KeyedMutator<PermissionsRecord>;
} & {};

export const permissionsStore = createAdvancedStore<PermissionsStore>("Permissions");
export const usePermissionsStore = permissionsStore.useContext;

//

export type PermissionData =
  | { permission: false; error: true; message: string; action: PermissionErrorAction }
  | { permission: true; error: false; message?: undefined; action?: undefined };

export function usePermission(permissionAction: PermissionActions): PermissionData {
  const permissions = usePermissionsStore((s) => s.permissions);
  const permission = permissions[permissionAction];

  if (permission.permission) return { permission: true, error: false };

  return {
    permission: false,
    error: true,
    message: permission.error.message,
    action: permission.error.data?.action ?? "UPGRADE_SUBSCRIPTION",
  };
}

//

export function useGetPermissionStoreData(): PermissionsStore | undefined {
  const { data, mutate } = useServerAction(
    { key: "permissions", organizationId: true },
    clientApi.permission.getPermissions,
  );

  if (!data) return;

  return { mutate, permissions: data };
}
